import { ProjectPermission } from 'modules/domains/project';
import { useHasProjectPermission } from 'utils/hooks/useHasProjectPermission';

export const useCanManageCatalogs = () => useHasProjectPermission(ProjectPermission.ManageCatalogs);
